export const productImage = ( product, isPresentation = true ) => {
  if ( product && product.imageLso ) {
    return !isPresentation && product.imageThumb ? product.imageThumb : product.imageLso;
  }
  return `./api/productImage/${ encodeURIComponent( product.code || product ) }`;
};
  
export const imageFrom = refUrl => (refUrl?.substring(0,4).includes('http')|| refUrl?.substring(0,1).includes('/'))? refUrl : (typeof site_location !== 'undefined' && site_location === 'root') ? refUrl: ('../' + refUrl);

export const helpImage = helpImageName => helpImageName && ((typeof site_location !== 'undefined' && site_location === 'root') ? `./api/helpImage/${helpImageName}` : `../api/helpImage/${helpImageName}`) ;